import { useHits } from 'react-instantsearch'

import OpportunitiesTable from '@/components/table-archive/OpportunitiesTable'

export default function TableArchiveItems({ columns }: { columns: string[] }): JSX.Element {
  const { items: hits } = useHits() as unknown

  if (!hits?.length || !columns?.length) {
    return <p>No results could be found</p>
  }

  return <OpportunitiesTable columns={columns} opportunities={hits} />
}
